var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "400" },
      on: { "click:outside": _vm.cancelAddAnchor },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "btn",
                      attrs: { disabled: _vm.addBtnDisabled, text: "" }
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._v(_vm._s(_vm.$t("New")))]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "popup add_store_popup" },
        [
          _c("h3", { staticClass: "page-title-bar" }, [
            _c("i", { staticClass: "ico ico-multi" }),
            _vm._v(_vm._s(_vm.$t("New Anchor")) + " ")
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("v-text-field", {
                    staticClass: "form-input",
                    attrs: {
                      label: _vm.Label_LabelId,
                      placeholder: _vm.$t("Input the label ID"),
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      clearable: ""
                    },
                    on: { keydown: _vm.clearTabindex },
                    model: {
                      value: _vm.labelId,
                      callback: function($$v) {
                        _vm.labelId = $$v
                      },
                      expression: "labelId"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("v-text-field", {
                    staticClass: "form-input",
                    attrs: {
                      label: _vm.Label_PositionId,
                      placeholder: _vm.$t("Input the location ID"),
                      maxlength: 50,
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      clearable: ""
                    },
                    on: { keydown: _vm.clearTabindex },
                    model: {
                      value: _vm.positionId,
                      callback: function($$v) {
                        _vm.positionId = $$v
                      },
                      expression: "positionId"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "d-flex justify-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn",
                  attrs: { text: "", icon: "" },
                  on: { click: _vm.addAnchor }
                },
                [_vm._v(_vm._s(_vm.$t("Save")))]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "btn",
                  attrs: { text: "", icon: "" },
                  on: { click: _vm.cancelAddAnchor }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }